import { Model } from '@vuex-orm/core'

export default class Task extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'tasks'

  static primaryKey = '_id'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields () {
    return {
      _id: this.attr(null),
      candidate_id: this.attr(null),
      job_id: this.attr(null),
      date: this.attr(null),
      comment: this.attr(null),
      completed: this.attr(null),
      completed_at: this.attr(null),
      completed_user_id: this.attr(null),
      assigned_user_id: this.attr(null),
      author_user_id: this.attr(null)
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Task.js